import React from 'react';
import '../styles/App.css'

export const Footer = ()=>{
    return(
       
<footer className="page-footer font-small blue">  
  <div class="footer-copyright text-center py-3">© 2020 Copyright:
    <a href="https://github.com/petitsarr " target="_blank" className ="mylien" > JO DEV</a>
  </div>
</footer>

    )
}